type RangeFilter = {
  min?: unknown;
  max?: unknown;
  variance?: unknown;
  percentage?: unknown;
  exact?: unknown;
};

const isRangeFilter = (value: unknown): value is RangeFilter =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const hasActiveRangeValue = (value: unknown) => Boolean(value);

export const countActiveFilters = (filters?: Record<string, unknown>): number =>
  Object.values(filters ?? {}).reduce<number>((acc, val) => {
    if (typeof val === 'string' && val.length > 0) return acc + 1;

    if (isRangeFilter(val)) {
      if ([val.min, val.max, val.variance, val.percentage, val.exact].some(hasActiveRangeValue)) {
        return acc + 1;
      }
    } else if (typeof val === 'boolean') {
      return acc + 1;
    }

    return acc;
  }, 0);
